
<template>
	<div class="page_content create-section">

		<b-col cols="12 channel-details-page">
			<div class="page_heading">
				<div class="col-5 module_heading">
				  <span class="module_icon icon-channel"></span>
					<span class="module_type_name">Channel Detail</span>
				</div>
        <div class="col-7 btn_container">
          <template v-if="isEditClicked">
            <b-button @click="updateChannel" aria-label="save">save</b-button>
            <b-button @click="isEditClicked = false" aria-label="cancel">cancel</b-button>
          </template>
          <template v-else>
            <b-button @click="isEditClicked = true" aria-label="edit">edit</b-button>
            <b-button :to="{ name: 'listChannels' }" aria-label="back">back</b-button>
          </template>
        </div>
			</div>
			<div class="content-section">
				<div class="row content-row">
				  <div class="col-6 row">
  					<div class="col-4 form-label">Title <sup>*</sup></div>
  					<div class="col-7" :class="{'detail-container': !isEditClicked}" :style="{background: isEditClicked ? '#fff' : '#e6e6e6'}">
              <template v-if="isEditClicked">
                <input type="text" style="margin-left: -15px; width: 104%;" v-model="channelDetail.channelName"></input>
              </template>
              <template v-else>
                {{channelDetail.channelName}}
              </template>
            </div>
				  </div>
				  <div class="col-6 row">
  					<div class="col-4 form-label" >External Id<sup>*</sup></div>
  					<div class="col-7 detail-container" style="background: #e6e6e6;">{{channelDetail.externalId}}</div>
				  </div>
				</div>
				<div class="row content-row">
				  <div class="col-6 row">
					<div class="col-4 form-label" id="title">Entity Id</div>
					<div class="col-7 detail-container" style="background: #e6e6e6;">{{channelDetail.entityId}}</div>
				  </div>
				  <div class="col-6 row">
					<div class="col-4 form-label" id="externalId">Entity Type</div>
					<div class="col-7 detail-container" style="background: #e6e6e6;">{{channelDetail.entityType}}</div>
				  </div>
				</div>
			</div>
            <div class="content-section">
				<b-row>
					<b-col cols="6">
						<div class="search_field">
							 <input type="text" class="input-search" placeholder="search for users to add" aria-label="search by name" v-model.trim="searchTerm" @input="searchUser" style="float: left;">
							 <div class="clear-btn" v-if="this.searchTerm.length > 0" @click="searchUser">
								<b-btn @click="searchTerm = ''" aria-label="clear">X</b-btn>
							 </div>
						</div>

					  <ul v-if="userList && userList.length > 0">
						<li v-for="usr in userList"><span class="user-name">{{usr.firstName}} {{usr.lastName}}</span> <button class="btn" v-if="usr.canAdd" @click="addParticipant(usr)" aria-label="add">add</button></li>
					  </ul>
					  <div class="no-result" v-else>No results</div>
					</b-col>
					<b-col cols="6">
					  <p>Participants: </p>
					  <ul v-if="channelDetail.participants && channelDetail.participants.length > 0">
						<li v-for="p in channelDetail.participants">{{p.firstName}} {{p.lastName}} <button @click="deleteParticipant(p)">X</button></li>
					  </ul>
					  <p v-else>No participants in this channel</p>
					</b-col>
				</b-row>
		    </div>


		</b-col>


	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'channelDetail',
  props: ['uuid'],
  components: {
  },
  data: () => {
    return {
      searchTerm: '',
      userRoles: ['Admin', 'Employer Admin', 'Instructor', 'Observer', 'Curator', 'Advisor', 'Student', 'Recruiter', 'Prospective Student'],
      selectedRoles: ['Admin', 'Employer Admin', 'Instructor', 'Observer', 'Curator', 'Advisor', 'Student', 'Recruiter', 'Prospective Student'],
      userList: [],
      pageSize: 50,
      isEditClicked: false
    }
  },

  mounted () {
    this.loadChannel()
  },

  methods: {
    ...mapActions([
      'loadChannelDetail',
      'loadUsersForRole',
      'loadAddParticipant',
      'loadDeleteParticipant',
      'loadCreateChannel'
    ]),
    addParticipant (usr) {
      this.loadAddParticipant({usr: usr, uuid: this.uuid}).then(data => {
        this.loadChannel()
        this.userList = []
      })
    },
    deleteParticipant (usr) {
      this.loadDeleteParticipant({usr: usr, uuid: this.uuid}).then(data => {
        this.loadChannel()
        this.userList = []
      })
    },
    async loadChannel () {
      await this.loadChannelDetail(this.uuid)
    },
    isParticipant (uuid) {
      if (this.channelDetail.participants && this.channelDetail.participants.length > 0) {
        for (var i = 0; i < this.channelDetail.participants.length; i++) {
          if (this.channelDetail.participants[i].userUuid === uuid) {
            return false
          }
        }
      }
      return true
    },
    searchUser () {
      this.refreshList()
    },
    refreshList () {
      this.userList = []
      if (this.searchTerm.length > 0) {
        this.getUsersForRole()
      }
    },
    getUsersForRole () {
      var roles = this.getSelectedRoles()
      var searchString = $.trim(this.searchTerm)
      var name = (searchString.length === 0) ? undefined : searchString
      this.fetchUsersForRole(roles, this.currentInstitutionId, 0, this.pageSize, name)
    },
    getSelectedRoles () {
      var roleString = ''
      var roles = this.selectedRoles
      for (var i = 0; i < roles.length; i++) {
        roleString += roles[i]
        if (i < (roles.length - 1)) {
          roleString += '|'
        }
      }
      return roleString
    },
    fetchUsersForRole (role, parentSpaceId, page, pageSize, name) {
      var data = {
        role: role,
        parentSpaceId: parentSpaceId,
        page: page,
        count: pageSize,
        name: name
      }
      this.loadUsersForRole(data).then(res => {
        this.userList = []
        $.each(res.content, (i, user) => {
          var canAdd = this.isParticipant(user.uuid)
          var result = {
            userUuid: user.uuid,
            firstName: user.firstName,
            lastName: user.lastName,
            middleName: user.middleName,
            externalId: user.externalId,
            canAdd: canAdd
          }
          this.userList.push(result)
        })
      })
    },
    updateChannel () {
      this.showLoader()
      this.channelDetail.title = this.channelDetail.channelName
      this.loadCreateChannel({channel: this.channelDetail}).then(res => {
        this.hideLoader()
        if (res) {
          this.isEditClicked = false
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Successfully updated channel with name ' + this.channelDetail.channelName
          })
        } else {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'Please try again.'
          })
        }
      })
    },
    showLoader () {
      this.$parent.$refs.loadingModal.show()
    },
    hideLoader () {
      this.$parent.$refs.loadingModal.hide()
    }
  },

  computed: {
    ...mapState({
      'channelDetail': state => state.channel.channelDetail
    }),
    currentInstitutionId () {
      var userObj = JSON.parse(localStorage.getItem('userobj'))
      return userObj.institutionId
    }
  },

  watch: {
  }
}
</script>
<style>
.margin-top-10 {
  margin-top: 10px;
}
.margin-top-20 {
  margin-top: 20px;
}
.margin-top-30 {
  margin-top: 30px;
}
.no-border {
  border: none;
}
.margin-left-20 {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/app/channel/components/ChannelDetail.vue